import { render, staticRenderFns } from "./statusConfirms.vue?vue&type=template&id=675288bd"
import script from "./statusConfirms.vue?vue&type=script&lang=js"
export * from "./statusConfirms.vue?vue&type=script&lang=js"
import style0 from "./statusConfirms.vue?vue&type=style&index=0&id=675288bd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports